import {
  PutAutotriageFeedbackRequest,
  PutAutotriageFeedbackResponse,
} from "@protos/ai/v1/triage";
import { authPut } from "@shared/api";

export interface PutAutotriageFeedbackParams {
  orgId: number;
  request: PutAutotriageFeedbackRequest;
}

export const putAutotriageFeedback = async ({
  orgId,
  request,
}: PutAutotriageFeedbackParams): Promise<PutAutotriageFeedbackResponse> => {
  const response = await authPut<
    PutAutotriageFeedbackRequest,
    PutAutotriageFeedbackResponse
  >(`/api/ai/deployments/${orgId}/autotriage_feedbacks`, request);
  return PutAutotriageFeedbackResponse.fromJSON(response);
};
